// 权限分配
const functionPrivilege: string =
    sessionStorage.getItem("functionPrivilege") || "[]";
const privileges: any = JSON.parse(functionPrivilege);
let role_menus: string[] = privileges || [];
role_menus = role_menus.filter((item: any) => item);

export const checkPrivilege = (code: any) => {
    role_menus =  ["home","globalPay","scanPay","payChannelList","payCurrencyList","payConfigList","payOrderList","internationalRemittanceCurrencyConversionList","internationalRemittanceCountriesList","internationalRemittanceSlippageList","internationalRemittanceCreditedTimesList","internationalRemittanceList","internationalRemittanceLimitList","internationalRemittanceChannelList","mine","amount","card","level","user","member","settings","recharge","withdrawal","balanceLog","cardMain","product","cardRecord","cardTransaction","holder","manager","role","privilege","notice","config","apply","importCard","userAddress","email","transfer","virtualVip","vipCardTask","safeBox","safeBoxTransferList","safeBoxProfitList","safeBoxProfitList","banner","userTransfer"]
    
    if (code && code.length && Array.isArray(code)) {

        return role_menus?.some((item: any) => {
            return code?.some((e: string) => item === e);
        });
    }
    return role_menus?.some((item: any) => item === code);
};

export {treeToArr, getTreeFirstValue} from "./tools";
